"use client";

import { Settings2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface AssetAllocationSettingsModalProps {
  includeCash: boolean;
  onIncludeCashChange: (checked: boolean) => void;
}

export function AssetAllocationSettingsModal({
  includeCash,
  onIncludeCashChange,
}: AssetAllocationSettingsModalProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8">
          <Settings2 className="h-4 w-4" />
          <span className="sr-only">Open allocation settings</span>
        </Button>
      </DialogTrigger>

      <DialogContent size="sm">
        <DialogHeader>
          <DialogTitle>Allocation settings</DialogTitle>
          <DialogDescription>
            Choose how the asset allocation chart should be calculated.
          </DialogDescription>
        </DialogHeader>

        <div className="flex items-start justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <Label htmlFor="include-cash" className="text-base">
              Include cash
            </Label>
            <p className="text-sm text-muted-foreground">
              Adds fiat balances to the allocation chart.
            </p>
          </div>

          <Switch
            id="include-cash"
            className="mt-0.5"
            checked={includeCash}
            onCheckedChange={onIncludeCashChange}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
